module.exports = __webpack_public_path__ + "static/media/face-check.be1e36ae.png";